<template>
  <div class="carList">
    <Header title="我的车辆" :show="true" />
    <div class="car">
      <!-- <van-cell-group inset>
        <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
        >
          <van-cell v-for="item in list" :key="item.carId" :title="item.carNo" icon="logistics">
            <template #label>
              <van-radio-group v-model="radio">
                <van-radio name="1">单选框 1</van-radio>
                <van-radio name="2">单选框 2</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
        </van-list>
      </van-cell-group> -->
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
      >
        <div v-for="(item,index) in list" :key="item.carId" class="carCard">
          <van-cell-group inset>
            <van-cell icon="logistics">
              <template #title>
                <span>{{item.carNo}}</span>
              </template>
            </van-cell>
            <van-cell>
              <template #title>
                <van-radio-group v-model="radio" @change="changeRad">
                  <van-radio :name="index" checked-color="#ee0a24" icon-size="15px" @click="isDefaultHandle(item.carId)">设为默认</van-radio>
                </van-radio-group>
              </template>
              <template #right-icon>
                <van-icon name="edit" @click="goUpdateCar(item.carId)"></van-icon>
              </template>
            </van-cell>
          </van-cell-group>
        </div>
      </van-list>
      <div class="carCard">
        <van-cell-group inset>
          <van-button type="default" @click="goAddCar">+添加车辆</van-button>
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import { getCarList, setCarDefault } from 'api/car'

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      radio: -1,
      radioChange: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    onLoad() {
      getCarList().then((res)  => {
        this.loading = false
        this.finished = true
        if (res.status == 200) {
          this.list = res.data
        } else {
          this.$error(res.message)
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
        });
      })
    },
    isDefaultHandle(carId)  {
      setCarDefault(carId).then((res) => {
        if (res.status == 200) {
          if (!this.radioChange) {
            this.radio = -1
          }
          this.radioChange = false
          this.$successSync("设置成功", () => {
          });
        } else {
          this.$error(res.message)
        }
      })
    },
    goAddCar() {
      this.$push({
        path: "/addCar",
      });
    },
    goUpdateCar(carId) {
      this.$push({
        path: "/addCar?carId=" + carId 
      })
    },
    changeRad(event) {
      this.radioChange = true
    }
  }
}
</script>
<style scoped lang="less">
.carCard{
  margin: 10px 16px 0px 16px;
  overflow: hidden;
  border-radius: 8px;
}
/deep/ .van-button {
  width: 100%;
  border: none;
  line-height: var(--footer-height);
}
</style>
